import { Button } from 'antd';
import { useRouteError } from 'react-router-dom'

export default function ErrorPage() {
  const error = useRouteError() as any
  console.error(error)


  // 检查错误类型
  if (error.message.includes("Failed to fetch")) {
    // 如果是资源加载失败，提示用户刷新页面
    return (
      <div style={{ padding: '30px' }}>
        <h2>版本有更新，请刷新使用新版本</h2>
        <Button onClick={() => window.location.reload()}>刷新页面</Button>
      </div>
    );
  }

  // 默认的错误处理
  return (
    <div>
      <h2>发生了一个错误: {error.message}</h2>
      <button onClick={() => window.location.reload()} >重试</button>
    </div>
  );

  // return (
  //   <div id='error-page'>
  //     <h1>Oops!</h1>
  //     <p>Sorry, an unexpected error has occurred.</p>
  //     <p>
  //       <i>{error.statusText || error.message}</i>
  //     </p>
  //   </div>
  // )
}
